import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { REMAINDERS } from "../constant/remainders.constant";

@Injectable({
  providedIn: "root",
})
export class RemaindersService {
  requestOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "my-auth-token",
    }),
  };
  constructor(private http: HttpClient) {}

  public remaindersCreate(data: any) {
    return this.http.post(`${REMAINDERS.CREATE}`, data);
  }

  public remaindersList(data: any) {
    return this.http.post(`${REMAINDERS.LIST}`, data);
  }
}
